


























































import { Component, Vue, Mixins } from 'vue-property-decorator'
import Template from '../../mixins/Template.vue'
import GridLayout from '@/components/Grid.vue'

@Component({
  components: {
    GridLayout
  }
})
export default class Default extends Mixins(Template) {}
